<template>
  <TemplateView>
    <div class="container">
      <div class="agreement">
        <div class="agreement__grid">
          <div
            class="agreement__button"
            :class="{ active: languageSelect.id === lang.id }"
            v-for="(lang, index) in languages"
            :key="index"
            @click="onLanguageChange(lang)"
          >
            <div class="agreement__button_left">
              <img :src="lang.image.svg" alt="" />
              <span class="agreement__button__text f20">{{ lang.name }}</span>
            </div>
          </div>
        </div>
        <v-form ref="form" lazy-validation v-model="valid">
          <label v-if="createPage || editingAllowed">{{
            localStorage.translations.pages['setting-offer_agreement'].labels.name
          }}</label>
          <div class="f18 name" v-else>
            {{
              localStorage.translations.pages['setting-offer_agreement'].labels.name + ': ' + name
            }}
          </div>
          <v-text-field
            v-if="createPage || editingAllowed"
            outlined
            height="48px"
            :placeholder="localStorage.translations.pages['setting-offer_agreement'].labels.name"
            v-model="name"
            :rules="[inputRules.required, inputRules.max100]"
          />
          <template v-for="(lang, index) in languages">
            <TiptapVuetify
              v-if="createPage || editingAllowed"
              v-show="lang.id === languageSelect.id"
              :key="index"
              class="textEditor"
              v-model="text[lang.id]"
              :extensions="extensions"
              :toolbar-attributes="{ color: 'rgb(39, 127, 175)' }"
            />
            <div
              class="showText"
              v-else
              v-show="lang.id === languageSelect.id"
              v-html="text[lang.id]"
              :key="lang.id"
            ></div>
          </template>
        </v-form>
        <OfferAgreementPostModal
          v-if="
            $route.name === 'settingOfferAgreementShow' &&
            checkAllLanguageLength() &&
            offerAgreementShow.published == 0
          "
          :name="name"
        />
        <div class="buttonGrid">
          <!-- <BaseButton
                v-if="createPage || (!createPage && editingAllowed && checkChangeUnsave())"
                :text="localStorage.translations.pages.common.buttons['sohranit']"
                @click.native="createOrUpdate"
                default_icon="button-save"
            /> -->
          <BaseButton
            v-if="!createPage && editingAllowed"
            :text="localStorage.translations.pages.common.buttons.otmenit"
            reverse
            @click="onCancelEditing"
          />
        </div>
        <div class="fixedBtn">
          <BaseTooltip
            v-if="createPage || (!createPage && editingAllowed && checkChangeUnsave())"
            :tooltip="localStorage.translations.pages.common.buttons['sohranit']"
            max-content
          >
            <BaseButton
              @click="createOrUpdate"
              round
              size="60"
              icon_only
              default_icon="button-save"
              class="mt-2"
            />
          </BaseTooltip>
        </div>

        <template />
        <LoadingAnimation v-if="loadingAnimation" />
        <EditBtn
          v-if="
            $userCheckAccess({
              abilities: 'edit_user_agreement',
            }) &&
            $route.name === 'settingOfferAgreementShow' &&
            offerAgreementShow.published == 0
          "
          :fixed="true"
          :toName="'settingOfferAgreementShowEdit'"
          :id="$route.params.id"
        />
      </div>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import LoadingAnimation from 'components/LoadingAnimation'
import OfferAgreementPostModal from 'components/setting/offerAgreement/OfferAgreementPostModal'
import EditBtn from 'components/EditBtn'

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'
// import ButtonImageAdd from 'components/ButtonImageAdd'
// import ButtonAdd from 'components/ButtonAdd'

export default {
  name: 'settingOfferAgreementShow',
  components: {
    LoadingAnimation,
    TiptapVuetify,
    OfferAgreementPostModal,
    EditBtn,
    // ButtonImageAdd,
    // ButtonAdd,
  },
  data() {
    return {
      languageSelect: null,
      name: '',
      test: '',
      text: {},
      valid: true,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    }
  },
  created() {
    if ($cookies.get('languageSelect')) {
      this.languageSelect = $cookies.get('languageSelect')
    }
    if (this.$route.params.id) {
      this.onOfferAgreementShow(this.$route.params.id)
    }
  },
  watch: {
    $route() {
      this.onActualData()
      // if (this.offerAgreementShow) {
      //   this.name = this.offerAgreementShow.name
      //   this.text = this.tryParseJSON(this.offerAgreementShow.data)
      //     ? JSON.parse(this.offerAgreementShow.data)
      //     : this.checkAllLanguage()
      //   this.checkAllLanguage()
      // }
    },
    name() {
      if (this.$route.name !== 'settingOfferAgreementShow') {
        this.onNavigationGuardianCheck({
          data: {
            offerAgreement: {
              name: this.name,
              text: this.text,
            },
          },
          overwrite: false,
        })
      }
    },
    text: {
      handler(val) {
        if (this.$route.name !== 'settingOfferAgreementShow') {
          this.onNavigationGuardianCheck({
            data: {
              offerAgreement: {
                name: this.name,
                text: this.text,
              },
            },
            overwrite: false,
          })
        }
      },
      deep: true,
    },
    offerAgreementShow() {
      if (
        this.$route.name === 'settingOfferAgreementShowEdit' &&
        this.offerAgreementShow.published == 1
      ) {
        this.$router.push({
          name: 'settingOfferAgreementShow',
          params: { id: this.$route.params.id },
        })
      }
      this.onActualData()
    },
  },
  computed: {
    ...mapGetters(['inputRules', 'loadingAnimation', 'apiDomain']),
    ...mapGetters('languages', ['languages']),
    ...mapGetters('offerAgreement', [
      'offerAgreementShow',
      // 'offerAgreementLast'
    ]),
    textSave() {
      return this.$route.params.id &&
        this.offerAgreementShow &&
        this.offerAgreementShow.data &&
        this.tryParseJSON(this.offerAgreementShow.data)
        ? JSON.parse(this.offerAgreementShow.data)
        : ''
    },
    createPage() {
      return this.$route.name === 'settingOfferAgreementCreate'
    },
    editingAllowed() {
      return this.$route.name === 'settingOfferAgreementShowEdit'
        ? this.offerAgreementShow
          ? this.offerAgreementShow.published == 0
          : false
        : false
    },
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    ...mapActions('offerAgreement', [
      'onOfferAgreementShow',
      'onOfferAgreementCreate',
      'onOfferAgreementUpdate',
      // 'onOfferAgreementLast'
    ]),
    ...mapMutations('offerAgreement', ['setOfferAgreementShow']),
    ...mapActions('navigationGuardian', [
      'onNavigationGuardianCheck',
      'offNavigationGuardianCheck',
    ]),
    onActualData() {
      if (Object.keys(this.offerAgreementShow).length) {
        this.name = this.offerAgreementShow.name
        this.text = this.tryParseJSON(this.offerAgreementShow.data)
      } else {
        if (this.languages) {
          this.checkAllLanguage()
        }
      }
      if (this.$route.name !== 'settingOfferAgreementShow') {
        this.onNavigationGuardianCheck({
          data: {
            offerAgreement: {
              name: this.name,
              text: this.text,
            },
          },
          overwrite: true,
        })
      }
    },
    async onCancelEditing() {
      await this.offNavigationGuardianCheck()
      this.$router.push({
        name: 'settingOfferAgreementShow',
        params: { id: this.$route.params.id },
      })
    },
    tryParseJSON(jsonString) {
      try {
        var o = JSON.parse(jsonString)
        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return this.checkAllLanguage()
    },
    onLanguageChange(lang) {
      this.languageSelect = lang
    },
    validate() {
      return this.$refs.form.validate()
    },
    checkAllLanguage() {
      console.log('checkAllLanguage')
      for (let lang in this.languages) {
        let langId = this.languages[lang].id
        if (!this.text[langId]) {
          this.$set(this.text, langId, '')
          // this.text[langId] = ''
        }
      }
    },
    checkChangeUnsave() {
      if (JSON.stringify(this.textSave) === JSON.stringify(this.text)) {
        return false
      } else {
        return true
      }
    },
    checkAllLanguageLength() {
      if (JSON.stringify(this.textSave) === JSON.stringify(this.text)) {
        let result
        for (let lang in this.languages) {
          let langId = this.languages[lang].id
          if (this.text[langId] && this.text[langId].length > 0) {
            result = true
          } else {
            result = false
            return result
          }
        }
        return result
      } else {
        return false
      }
    },
    createOrUpdate() {
      if (this.validate()) {
        if (this.$checkNavigationGuardianChange('offerAgreement')) {
          let data = {
            // id: !this.create ? this.workDocsWorkAreaShow.id : null,
            name: this.name,
            data: JSON.stringify(this.text),
          }
          if (!this.$route.params.id) {
            this.onOfferAgreementCreate(data)
              .then(async (response) => {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications['uspeshno-cozdano'],
                    IsError: false,
                  },

                  { root: true },
                )
                await this.offNavigationGuardianCheck()
                this.$router.push({
                  name: 'settingOfferAgreementShow',
                  params: { id: response.data.id },
                })
              })
              .catch((err) => {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              })
          } else {
            data.id = this.$route.params.id
            this.onOfferAgreementUpdate(data)
              .then(async (response) => {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                await this.offNavigationGuardianCheck()
                this.$router.push({
                  name: 'settingOfferAgreementShow',
                  params: { id: response.data.id },
                })
                this.onOfferAgreementShow(this.$route.params.id)
              })
              .catch((err) => {
                if (err.response.data.errors) {
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message: this.localStorage.translations.pages.common.notifications['oshibka'],
                      IsError: true,
                    },
                    { root: true },
                  )
                }
              })
          }
        }
      }
    },
  },
  beforeDestroy() {
    this.setOfferAgreementShow([])
  },
}
</script>

<style lang="scss" scoped>
:deep() .tiptap-vuetify-editor {
  .tiptap-vuetify-editor__action-render-btn {
    svg {
      path {
        fill: rgb(255, 255, 255);
      }
    }
    .tiptap-vuetify-editor__btn-icon {
      color: rgb(255, 255, 255);
    }
    &.v-btn--active {
      background: #bedbeb;
      svg {
        path {
          fill: #000000;
        }
      }
      .tiptap-vuetify-editor__btn-icon {
        color: #000000;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.agreement {
  position: relative;
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    gap: 24px;
    margin-bottom: 30px;
  }
  &__button {
    background: #ffffff;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 20px;
    align-items: center;
    align-content: center;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    justify-content: space-between;
    column-gap: 20px;
    img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 1px solid #bedbeb;
      object-fit: cover;
    }
    &_left {
      display: grid;
      grid-template-columns: max-content auto;
      align-items: center;
      column-gap: 28px;
    }
    &__text {
      text-transform: capitalize;
    }
    &:hover:not(.active) {
      box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
    }
    &.active {
      border: 1px solid #16558f;
      pointer-events: none;
    }
  }
  .name {
    margin-bottom: 30px;
  }
  .buttonGrid {
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 20px;
  }
  .textEditor {
    margin: 20px 0;
  }
  .showText {
    background: #ffffff;
    padding: 25px;
    margin-bottom: 20px;
  }
}
</style>
